/**
 * ⚠️ DỮ LIỆU TẠM — CHƯA CÓ API
 *
 * Còn đúng một khối chưa có endpoint:
 *   · Livestream    (màn 03) — luồng đang phát + lịch phát sóng
 *
 * Tin tức và Sự kiện đã rời khỏi đây: bài viết soạn ở backoffice và đọc qua
 * /public/news — xem getPublicNews/getPinnedNews trong helpers/sportbookService.ts,
 * kiểu dữ liệu ở interfaces/news.ts.
 *
 * File này giữ dữ liệu giả để phần giao diện còn lại dựng được đúng thiết kế.
 * Khi backend có endpoint livestream, thay các hàm `fetch*` bên dưới bằng lời gọi
 * trong helpers/sportbookService.ts — component không phải sửa gì vì đã dùng đúng
 * hình dạng dữ liệu này.
 */

export interface LiveStream {
  id: string;
  title: string;
  subtitle: string;
  viewers: number;
  isLive: boolean;
  startAt?: string;
  thumbnail: string;
}

export interface BroadcastSlot {
  id: string;
  time: string;
  title: string;
  channel: string;
}

export interface LiveMatch {
  round: string;
  format: string;
  frame: string;
  homeName: string;
  homeRank: string;
  homeScore: number;
  awayName: string;
  awayRank: string;
  awayScore: number;
  note: string;
}

/* Ảnh minh hoạ dạng data-URI: khối gradient navy → không gọi mạng ngoài. */
const shot = (a: string, b: string) =>
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="160" height="100">
      <defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stop-color="${a}"/><stop offset="1" stop-color="${b}"/>
      </linearGradient></defs>
      <rect width="160" height="100" fill="url(#g)"/>
      <circle cx="118" cy="34" r="13" fill="#F2F3EF" opacity="0.85"/>
      <circle cx="118" cy="34" r="5" fill="#0A0D17" opacity="0.5"/>
      <rect x="0" y="72" width="160" height="28" fill="#0A0D17" opacity="0.35"/>
    </svg>`
  );



const FEATURED_MATCH: LiveMatch = {
  round: "Bán kết · Pool 9 bi",
  format: "Race 11",
  frame: "Ván 10",
  homeName: "N.H. Phong",
  homeRank: "Hạng 1 VN",
  homeScore: 6,
  awayName: "T.Q. Duy",
  awayRank: "Hạng 2 VN",
  awayScore: 4,
  note: "Phong đang ở lượt cơ · chạm bi mục tiêu số 5",
};

const STREAMS: LiveStream[] = [
  {
    id: "s1",
    title: "Bàn 2 · Khôi vs Thành",
    subtitle: "Vòng bảng",
    viewers: 3204,
    isLive: true,
    thumbnail: shot("#123A2C", "#0A0D17"),
  },
  {
    id: "s2",
    title: "Bàn 3 · Vòng loại nữ",
    subtitle: "Vòng loại",
    viewers: 1876,
    isLive: true,
    thumbnail: shot("#3A1A16", "#0A0D17"),
  },
  {
    id: "s3",
    title: "Carom 3 băng · CLB Q.5",
    subtitle: "Vòng bảng",
    viewers: 942,
    isLive: true,
    thumbnail: shot("#16324A", "#0A0D17"),
  },
  {
    id: "s4",
    title: "Chung kết đôi nam nữ",
    subtitle: "Sắp phát",
    viewers: 0,
    isLive: false,
    startAt: "19:30",
    thumbnail: shot("#1B2436", "#0A0D17"),
  },
];

const SCHEDULE: BroadcastSlot[] = [
  { id: "b1", time: "17:00", title: "Tứ kết 3 · Phong vs Khôi", channel: "Biadi TV" },
  { id: "b2", time: "19:30", title: "Chung kết đôi nam nữ", channel: "YouTube" },
  { id: "b3", time: "21:00", title: "Bình luận sau trận", channel: "Biadi TV" },
];

/* Các hàm này cố tình bất đồng bộ để khi thay bằng API thật không phải
   đổi chữ ký ở phía component. */
export const fetchStreams = async (): Promise<LiveStream[]> => STREAMS;
export const fetchSchedule = async (): Promise<BroadcastSlot[]> => SCHEDULE;
export const fetchFeaturedMatch = async (): Promise<LiveMatch> => FEATURED_MATCH;

/**
 * Cờ để UI hiển thị nhãn "dữ liệu mẫu" — tắt khi đã nối API thật.
 *
 * Chỉ còn màn Trực tiếp dùng: trang chủ nay lấy tin tức và sự kiện từ API thật nên
 * đã bỏ nhãn này ở đó.
 */
export const IS_PLACEHOLDER_CONTENT = true;
